/* ============================================================================
   📝  CONTENU DU SITE HEARTCANVAS — TOUT EST ICI
   ----------------------------------------------------------------------------
   Modifie ce fichier pour changer TOUT le contenu du site (textes + images).
   Tu n'as PAS besoin de toucher aux autres fichiers.

   ▸ Pour changer un TEXTE   : remplace simplement le texte entre les guillemets.
                                Garde toujours les guillemets autour.
   ▸ Pour changer une IMAGE  : remplace l'URL entre guillemets par la tienne.
                                Tu peux glisser une image dans Lumi, copier
                                son lien (ex. https://static.lumi.new/...png)
                                et le coller à la place.
   ▸ Pour les apostrophes    : utilise \' à la place de ' dans un texte qui
                                contient déjà des apostrophes (ex: "L\'art").
   ▸ Pour les nouvelles lignes dans un titre : utilise \n
                                (ex: "Première ligne\nDeuxième ligne").

   Sauvegarde le fichier — le site se met à jour automatiquement. ✨
============================================================================ */

// ============================================================================
// 🖼️  IMAGES — change les URLs ici pour remplacer les visuels du site
// ============================================================================
export const images = {
  // Photo principale du hero (page d'accueil) — table d'atelier
  studioTable: 'https://static.lumi.new/material/8a/8ad067509a43409e627c46ae2979d521.png',

  // Mains tenant un pinceau — utilisé sur Accueil + Adultes
  handsBrush: 'https://static.lumi.new/material/84/849ae9b1d2a2535240221e5ee50780ce.png',

  // Image de l'offre "Crée le canevas de ta vie" — Accueil + Adultes
  canevasOffer: 'https://static.lumi.new/material/58/588f9f949f72a3ebcc5a832d0969dfb2.jpg',

  // Détail de matière / peinture — utilisé un peu partout
  paintDetail: 'https://static.lumi.new/60/60b82db94ad9810cb6314ec3b746e17f.png',

  // Vue d'atelier — utilisé sur Accueil + Adultes + Institutions
  atelierRoom: 'https://static.lumi.new/66/66a326ab334744bba84fd724209b1663.png',

  // Portrait d'Alexandra — Accueil + À propos
  alexandra: 'https://static.lumi.new/material/94/94f9b779782dd068c6eb61ce4b0e377b.jpg',

  // Peinture d'enfants (style Arno Stern) — Ateliers + Institutions
  kidsPainting: 'https://static.lumi.new/material/7a/7a07bdb7077e81f69bb9b8296b7f67e1.jpeg',

  // Image de l'offre "Geste libre" sur la page d'accueil
  gesteLibre: 'https://static.lumi.new/material/b3/b31dbf7d5d370737ddaecacaafde2791.jpeg',

  // Image de l'offre "Traverser le deuil par l'art" sur la page d'accueil
  deuil: 'https://static.lumi.new/material/28/28584b502f76c3f6606a84872a7585d9.jpg',
}

// ============================================================================
// 🔗  LIENS EXTERNES — change ici tes liens
// ============================================================================
export const links = {
  // Lien de réservation d'appel gratuit (Tidycal)
  booking: 'https://tidycal.com/heartcanvas/clarte',

  // Site artiste (s'ouvre dans un nouvel onglet)
  amanaliya: 'https://www.amanaliya.com',

  // Instagram HeartCanvas
  instagram: 'https://instagram.com/heartcanvas.art',

  // Facebook HeartCanvas
  facebook: 'https://facebook.com/heartcanvas.art',

  // Handle social (Instagram & Facebook)
  socialHandle: 'heartcanvas.art',

  // Coordonnées
  email: 'alexandra@heartcanvas.ch',
  phone: '+41 76 377 49 75',
}

// ============================================================================
// 🧭  NAVIGATION — labels du menu
// ============================================================================
export const nav = {
  brand: 'HeartCanvas',
  brandTagline: "· Transformation par l'art",
  ctaButton: 'Réserver un appel',
  items: [
    { to: '/', label: 'Accueil' },
    { to: '/adultes', label: 'Adultes' },
    { to: '/institutions', label: 'Institutions' },
    { to: '/a-propos', label: 'À propos' },
    { to: '/contact', label: 'Contact' },
  ],
}

// ============================================================================
// 🏠  PAGE ACCUEIL
// ============================================================================
export const home = {
  hero: {
    eyebrow: '',
    titleLines: [
      "L'art comme chemin",
      'de reconstruction.',
    ],
    subtitle: 'Prends ta place. Libère ce qui pèse. Retrouve ce qui vibre.',
    primaryCta: { label: 'Adultes', to: '/adultes' },
    secondaryCta: { label: 'Institutions', to: '/institutions' },
    instLine: 'Vous représentez une institution ? HeartCanvas intervient également auprès des jeunes en cadre institutionnel.',
    imageBadge: 'Atelier · 2025',
  },

  reconnaissance: {
    eyebrow: '— À qui ça s\'adresse',
    title: 'Tu te reconnais\npeut-être ici…',
    items: [
      "Tu sens qu'il y a quelque chose en toi qui attend d'émerger — mais tu ne sais pas comment y accéder.",
      "Tu cherches de la clarté — sur qui tu es, ce que tu veux, ce qui te freine — mais les mots ne suffisent pas.",
      "Tu portes quelque chose de lourd sans savoir comment le déposer.",
      "Tu traverses une période de perte de repères — tu ne sais plus très bien qui tu es ni où tu vas.",
      "Tu vis des difficultés relationnelles — avec tes proches, ta famille — et tu sens que ça vient de loin.",
      "Tu portes des schémas familiaux qui se répètent et tu voudrais enfin t'en libérer.",
    ],
    quoteSoft: "L'art n'est pas une question de talent.",
    quoteStrong: "C'est une expérience vivante où tu retrouveras de la fluidité, ta capacité à créer et à t'amuser — et une façon d'entrer en relation avec toi-même.",
  },

  methode: {
    eyebrow: '— L\'approche',
    title: 'La méthode HeartCanvas®',
    intro: "Un outil à la fois ludique et profond pour explorer ton histoire, activer tes ressources intérieures, retrouver qui tu es vraiment et poser les bases d'une sécurité intérieure.",
    steps: [
      {
        num: '01',
        title: 'Tu lâches prise',
        body: "Ici, il n'y a pas de beau à produire ni de technique à maîtriser. On laisse le mental de côté pour laisser le cœur s'exprimer — en passant du cerveau rationnel à celui des rêves, de la liberté et de l'intuition.",
      },
      {
        num: '02',
        title: 'Tu laisses venir',
        body: "Les couleurs, les gestes, le thème du jour — tout devient une invitation. Quelque chose monte à l'intérieur de toi. Tu le laisses se déposer sur le papier, sans attente ni jugement.",
      },
      {
        num: '03',
        title: 'Tu accueilles ce qui émerge',
        body: "Ce qui apparaît sur le papier révèle ce qui était là, enfoui en toi — ces schémas reçus de ta famille, ces façons d'être adoptées pour être aimé. Des ressources intérieures que tu ne soupçonnais pas, une clarté qui émerge, quelque chose qui attendait d'être vu. Pas besoin de l'analyser ni de l'expliquer — il suffit de prendre conscience et d'accueillir.",
      },
    ],
  },

  videoMethode: {
    eyebrow: '— En images',
    title: 'La méthode en vidéo',
    subtitle: "Alexandra t'explique comment ça se passe — en quelques minutes.",
    youtubeId: 'ozUKij6h1Cw',
  },

  offres: {
    eyebrow: '— Offres',
    title: 'Trois invitations\nà te transformer.',
    items: [
      {
        title: 'Crée le canevas de ta vie',
        body: "Un parcours en 10 séances pour explorer ton histoire, libérer ce qui t'alourdit et retrouver confiance, sens et équilibre — pour redonner du souffle à ton présent.",
        meta: 'En présentiel ou à distance',
        cta: 'En savoir plus',
        to: '/adultes',
        image: 'canevasOffer' as const,
      },
      {
        title: 'Geste libre',
        body: "Un espace créatif pour les enfants et adolescents — peindre librement, s'exprimer sans jugement et retrouver le plaisir naturel de créer.",
        meta: 'Sur Demande',
        cta: 'Me contacter',
        to: '/contact',
        image: 'gesteLibre' as const,
      },
      {
        title: "Traverser le deuil par l'art",
        body: "Certains deuils ne trouvent pas leurs mots. L'art offre un autre chemin — pour traverser, déposer et avancer doucement.",
        meta: 'Sur Demande',
        cta: 'Me contacter',
        to: '/contact',
        image: 'deuil' as const,
      },
    ],
  },

  quiTuEs: {
    eyebrow: '— Qui je suis',
    title: "Je suis Alexandra Goris, accompagnante en transformation par l'art — artiste professionnelle et fondatrice de HeartCanvas.",
    paragraphs: [
      "J'ai traversé une enfance et une adolescence marquées par de fortes turbulences familiales. Ce chemin a été long — mais c'est par l'art que je me suis reconstruite. La créativité a changé ma vie.",
      "Depuis plus de 20 ans j'accompagne des adultes et des jeunes sur le chemin de la reconstruction — diplômée en art-thérapie relationnelle de l'Institut de Psychosomatique de Paris.",
      "Mon histoire me rend particulièrement sensible à ceux qui portent des blessures du passé et cherchent à retrouver leur place.",
    ],
    cta: { label: 'En savoir plus', to: '/a-propos' },
  },

  invitationFinale: {
    eyebrow: '— Invitation',
    title: "Et si c'était le moment ?",
    body: "Un appel gratuit, sans engagement. Juste une rencontre.",
    ctaLabel: 'Je réserve',
    // ce CTA pointe vers le lien de réservation Tidycal (links.booking)
  },
}

// ============================================================================
// 👩‍🦰  PAGE ADULTES
// ============================================================================
export const adultes = {
  hero: {
    eyebrow: '— Adultes',
    title: "Crée le canevas de ta vie.",
    subtitle: "Un parcours en 10 séances pour explorer tes liens familiaux, libérer ce qui te pèse — et retrouver confiance en toi, stabilité et sécurité intérieure.",
  },

  pourQui: {
    eyebrow: '— Pour qui',
    title: 'Ce parcours est pour toi si…',
    items: [
      "Tu as souffert dans ton enfance ou ton adolescence — et tu sens que ça pèse encore aujourd'hui.",
      "Tu cherches un équilibre émotionnel et une confiance en toi que tu n'arrives pas à trouver en avançant seul.",
      "Tu es en quête de sens — sur qui tu es, ce que tu veux, là où tu vas.",
      "Tu traverses une période de perte de repères — tu ne sais plus très bien qui tu es ni où tu vas.",
      "Tu vis des difficultés relationnelles — avec tes proches, ta famille — et tu sens que ça vient de loin.",
      "Tu portes des schémas familiaux qui se répètent et tu voudrais enfin t'en libérer.",
    ],
  },

  pasPourtoi: {
    eyebrow: "— Ce parcours n'est pas pour toi si…",
    title: "Ce parcours n'est pas pour toi si…",
    items: [
      "Tu cherches une thérapie clinique ou un suivi psychologique.",
      "Tu n'es pas prêt(e) à explorer ton histoire personnelle et familiale.",
      "Tu attends une solution rapide sans t'impliquer dans le processus.",
    ],
  },

  videoMethode: {
    eyebrow: '— En images',
    title: 'La méthode en vidéo',
    subtitle: "Alexandra t'explique comment ça se passe — en quelques minutes.",
    youtubeId: 'ozUKij6h1Cw',
  },

  parcours: {
    eyebrow: '— Déroulé',
    title: 'Le parcours\nen 4 temps.',
    steps: [
      {
        num: 'I',
        title: "L'enfance",
        body: "On retourne là où tout a commencé — pour comprendre ce qui s'est construit en toi, et te donner une nouvelle place.",
        transition: "Ce regard ouvre la porte à quelque chose d'essentiel : comprendre que ton adolescence n'était pas un chaos, mais une suite logique.",
      },
      {
        num: 'II',
        title: "L'adolescence",
        body: "On revisite cette période souvent tumultueuse — les révoltes, les silences, ce qui a été étouffé. Pour enfin l'accueillir.",
        transition: "Ce que tu libères ici dégage de l'espace. L'adulte que tu es aujourd'hui peut enfin choisir depuis un endroit différent.",
      },
      {
        num: 'III',
        title: "L'adulte",
        body: "On transforme ce que tu as porté jusqu'ici. Pour choisir qui tu es vraiment — et non plus qui tu as dû être.",
        transition: 'Et puis vient le moment de rassembler.',
      },
      {
        num: 'IV',
        title: "L'intégration",
        body: "On rassemble tout le chemin parcouru. Tu t'ancres dans qui tu es, entier·e et apaisé·e.",
        transition: '',
      },
    ],
  },

  transformations: {
    eyebrow: '— Transformations',
    title: 'Ce que ça change concrètement.',
    intro: 'Pas des promesses. Ce que les personnes qui ont fait le parcours vivent réellement.',
    items: [
      {
        t: 'Une clarté nouvelle',
        b: "Comme si quelque chose que tu portais depuis longtemps s'était enfin déposé. Par la créativité, un déclic se produit, une direction émerge, une clarté s'installe là où tout semblait flou.",
      },
      {
        t: 'Se libérer des schémas transmis',
        b: "Enfant, nous adoptons inconsciemment les comportements, les croyances et les peurs de nos parents pour être aimés et acceptés. Ces schémas deviennent notre façon d'être — sans que nous en ayons conscience. Ce parcours te permet de prendre conscience de ces héritages invisibles, de comprendre comment ils t'ont façonné — et de choisir ce que tu veux en faire.",
      },
      {
        t: 'Retrouver une direction',
        b: "Quand on est à un carrefour dans sa vie — sans savoir vers où avancer — ce parcours offre l'impulsion qui manquait. Tu prends conscience de là où tu veux vraiment aller, et repars avec une direction plus claire.",
      },
      {
        t: 'Activer tes ressources intérieures',
        b: "Le mental cherche, analyse, tourne en rond — mais il ne trouve pas toujours les réponses. L'art permet de lâcher ce contrôle et d'entrer dans un autre espace : celui du cerveau droit, de l'imaginaire, de l'intuition. C'est là que tes ressources intérieures s'activent — et que tu accèdes naturellement à des réponses, de nouvelles envies, des élans que tu n'attendais pas.",
      },
      {
        t: "Poser les bases d'une sécurité intérieure",
        b: "Cette sensation de se sentir un peu plus bien en soi — moins dans la peur, plus ancré. Ce n'est pas une destination, c'est un chemin. Et ce parcours en est une étape réelle.",
      },
    ],
    quote: 'Ce parcours ne règle pas tout. Mais il libère quelque chose de réel.',
  },

  temoignages: {
    eyebrow: '— Témoignages',
    title: '« Elles ont vécu le parcours Crée le canevas de ta vie »',
    note: "",
    items: [
      {
        n: 'Delfine',
        context: 'Crée le canevas de ta vie',
        q: "Un espace pour me retrouver, explorer mon imaginaire et laisser émerger mes parts blessées avec douceur. La bienveillance et la guidance d'Alexandra ont transformé ma créativité en véritable chemin de guérison.",
        images: [
          'https://static.lumi.new/material/70/7004aa2b46c89090826490aacbb9fe26.png',
          'https://static.lumi.new/material/d1/d12fb6fb3978b1e7abf566e3f22b1004.png',
        ],
      },
      {
        n: 'Béa',
        context: 'Crée le canevas de ta vie',
        q: "Passer par la peinture m'a permis d'exprimer un monde intérieur enfoui en moi, sans chercher à le comprendre ni à le juger — juste l'accueillir. Comme un moment de méditation éveillée.",
      },
      {
        n: 'Ghislaine',
        context: 'Crée le canevas de ta vie',
        q: "Je n'imaginais pas pouvoir si rapidement transcender mes marques du passé. Je me sens comme un papillon qui aurait déchiré son cocon.",
      },
    ],
  },

  offre: {
    eyebrow: '— Offre',
    title: 'Crée le canevas\nde ta vie.',
    tagline: "Un parcours en 10 séances pour libérer ce qui pèse et retrouver qui tu es.",
    body: "La première étape, c'est un appel gratuit de 20 minutes. On se rencontre, tu poses tes questions, et on voit ensemble si ce parcours est fait pour toi.\n\nLe parcours se déroule en présentiel ou à distance, en petit groupe de 10 personnes maximum. Les dates de la prochaine session sont communiquées lors de l'appel.",
    cardLabel: '— Le parcours',
    details: [
      ['Format', '10 séances de 2h30'],
      ['Groupe', '10 personnes maximum'],
      ['Modalité', 'En présentiel ou à distance'],
      ['Tarif', '990 CHF'],
    ] as Array<[string, string]>,
    ctaLabel: 'Je réserve mon appel gratuit',
  },

  // Atelier complémentaire pour adultes — anciennement page Ateliers
  deuilOffre: {
    eyebrow: '— Deuil',
    title: "Traverser le deuil par l'art.",
    audience: 'Pour les adultes',
    paragraphs: [
      "Le deuil n'est pas seulement la perte d'un être cher. C'est tout ce qui se ferme — une relation, une vie qu'on avait imaginée, une partie de soi.",
      "Ces passages sont souvent traversés seuls, sans espace pour vraiment déposer ce qu'on vit.",
      "Cet atelier crée cet espace — par le geste, la couleur, la création. Pas pour effacer la perte. Pour la traverser autrement.",
    ],
    footnote: "Tu traverses un deuil ? Je suis là. Écris-moi.",
    ctaLabel: 'Me contacter',
  },

  invitationFinale: {
    eyebrow: '— Invitation',
    title: "Ce parcours t'appelle ?",
    body: 'Commence par un appel gratuit. Sans engagement. Juste une rencontre.',
    ctaLabel: 'Je réserve mon appel gratuit',
  },
}

// ============================================================================
// 🎨  ANCIENNE PAGE ATELIERS (conservé en référence — non utilisé)
// ============================================================================
export const ateliers = {
  hero: {
    eyebrow: '— Ateliers',
    title: 'Des espaces pour se déposer, se transformer, reprendre sa place.',
  },

  badge: 'Prochainement',

  items: [
    {
      num: '01',
      audience: 'Atelier 1 · Pour les enfants de 5 à 12 ans — Institutions uniquement',
      title: "Geste libre — atelier d'expression par l'art",
      paragraphs: [
        "Pas de modèle à reproduire. Pas de résultat attendu. Un espace où l'enfant est libre — de choisir ses couleurs, d'inventer son geste, de s'exprimer sans être jugé.",
        "Inspiré de la méthode Arno Stern, cet atelier offre aux jeunes un moment de liberté créative dans un cadre bienveillant et structuré.",
        "Les enfants découvrent l'émerveillement du mélange des couleurs, la liberté du grand geste sur de grandes feuilles — quelque chose que l'école ne leur offre plus.",
        "Ce que ça apporte concrètement : des enfants plus apaisés, plus disponibles, qui ont pu déposer quelque chose sans avoir besoin de le nommer.",
      ],
      footnote: 'Prochainement — me contacter pour en savoir plus.',
      ctaLabel: 'Me contacter',
      image: 'kidsPainting' as const,
      reverse: false,
    },
    {
      num: '02',
      audience: 'Atelier 2 · Pour les adultes',
      title: "Traverser le deuil par l'art",
      paragraphs: [
        "Le deuil n'est pas seulement la perte d'un être cher. C'est tout ce qui se ferme — une relation, une vie qu'on avait imaginée, une partie de soi.",
        "Ces passages sont souvent traversés seuls, sans espace pour vraiment déposer ce qu'on vit.",
        "Cet atelier crée cet espace — par le geste, la couleur, la création. Pas pour effacer la perte. Pour la traverser autrement.",
      ],
      footnote: 'Prochainement — me contacter pour en savoir plus.',
      ctaLabel: 'Me contacter',
      image: 'paintDetail' as const,
      reverse: true,
    },
  ],

  invitationFinale: {
    eyebrow: '— Et maintenant',
    title: 'Une question, un projet ?',
    body: "Les deux ateliers sont en préparation. Écrivez-moi pour être tenu·e informé·e ou pour discuter d'une intervention dans votre structure.",
    ctaLabel: 'Me contacter',
  },
}

// ============================================================================
// 🏫  PAGE INSTITUTIONS
// ============================================================================
export const institutions = {
  hero: {
    eyebrow: '— Institutions',
    title: "Un espace d'expression et de reconstruction pour les jeunes que vous accompagnez.",
  },

  aQui: {
    eyebrow: '— Public',
    title: "À qui ça s'adresse.",
    body: "Ces interventions s'adressent à toutes les structures qui accompagnent des jeunes — foyers, services de protection de la jeunesse, écoles, centres sociaux ou culturels.\n\nSelon vos besoins : un espace de création libre et joyeux avec le Geste libre, ou un parcours de reconstruction plus profond avec \u00ab\u00a0Crée le canevas de ta vie\u00a0\u00bb.",
  },

  constat: {
    eyebrow: '— Contexte actuel',
    title: 'Le constat.',
    paragraph1:
      "Depuis le Covid, une génération de jeunes s'est retrouvée coupée d'elle-même — de ses repères, de ses élans, de sa capacité à s'exprimer et à se projeter.",
    paragraph2:
      "Beaucoup de ces jeunes portent des choses qu'ils ne savent pas nommer. Pas parce qu'ils ne ressentent pas — mais parce qu'ils n'ont pas les outils pour les exprimer.",
    quote: "Les mots ne suffisent pas toujours. L'art, lui, ouvre un autre chemin.",
  },

  proposition: {
    eyebrow: '— Accompagnement',
    title: "Deux propositions pour vos jeunes.",
    gesteLibre: {
      title: "Geste libre",
      body: "Pas de modèle à reproduire. Pas de résultat attendu. Un espace où le jeune est libre — de choisir ses couleurs, d'inventer son geste, de s'exprimer sans être jugé.\n\nInspiré de la méthode Arno Stern, cet atelier offre aux jeunes un moment de liberté créative dans un cadre bienveillant et structuré.\n\nIls découvrent l'émerveillement du mélange des couleurs, la liberté du geste sur de grandes feuilles — un espace rare de création sans contrainte.\n\nCe que ça apporte concrètement : des jeunes plus apaisés, plus calmes et centrés — capables de déposer ce qu'ils portent sans avoir besoin de le nommer, et de repartir plus disponibles pour ce qui les attend.",
      photos: [
        'https://static.lumi.new/material/93/930cc4aa8ffe50849bee984f9f4f2d5a.jpg',
        'https://static.lumi.new/material/d4/d4a0778957016b9cface2d3c8b11be81.jpg',
        'https://static.lumi.new/material/9b/9bd0faabe6fbd9b95d713294e7992268.jpg',
        'https://static.lumi.new/material/13/1392cfb0a245cd292686929b3224e656.jpg',
      ],
    },
    canevas: {
      title: "« Crée le canevas de ta vie »",
      body: "Le parcours phare de HeartCanvas, adapté au cadre institutionnel et au rythme des jeunes que vous accompagnez.\n\nBeaucoup de jeunes que vous accompagnez ont grandi dans des environnements instables — portant des charges émotionnelles trop lourdes, ne sachant pas comment les gérer, cherchant leur place, essayant de se construire quand tout est trop confus.\n\n« Crée le canevas de ta vie » leur offre un espace bienveillant, sécurisant et structuré, où la peinture et l'expression visuelle deviennent des points d'appui pour se recentrer, mettre du sens sur ce qu'ils ont vécu et renouer avec eux-mêmes.\n\nSur une base de 10 séances — modulable selon les besoins, ils apprennent à identifier ce qui les limite, à comprendre leur histoire et leurs réactions, à apaiser les tensions intérieures et à retrouver un espace intérieur plus stable — les bases d'une sécurité intérieure.\n\nUn format structuré, sécurisant, qui respecte leur silence comme leur élan. Au sortir, ils sont plus disponibles à eux-mêmes — et à ce que vous leur proposez.",
    },
  },

  tarifs: {
    eyebrow: '— Tarifs',
    title: 'Sur devis.',
    body: "Contactez-nous pour discuter de vos besoins et établir un devis adapté à votre structure.",
  },

  parcours: {
    eyebrow: '— Parcours',
    title: 'Un parcours en profondeur.',
    body: 'Pour les structures qui souhaitent aller plus loin, je propose également « Crée le canevas de ta vie » en format présentiel — un parcours structuré sur plusieurs semaines pour accompagner les jeunes dans une transformation plus profonde.',
    ctaLabel: 'En savoir plus',
    ctaTo: '/adultes',
  },

  pourquoi: {
    eyebrow: '— Mon engagement',
    title: 'Pourquoi HeartCanvas.',
    paragraph1:
      "À 15 ans, j'étais moi-même suivie par la DGEJ — dans une famille marquée par la violence de mon père. C'est cet espace de protection qui m'a offert un premier repère au milieu du chaos.",
    paragraph2:
      "Mon chemin de reconstruction a été long. Des années de travail intérieur, de thérapie, d'introspection — et au cœur de tout ça, une évidence : la créativité m'a sauvée.\n\nTrente ans plus tard, je transmets ce que j'ai traversé et appris — comme artiste professionnelle depuis plus de 20 ans, diplômée en art-thérapie relationnelle de l'Institut de Psychosomatique de Paris, et fondatrice de HeartCanvas.\n\nSi j'accompagne ces jeunes aujourd'hui, c'est parce que je sais profondément ce que ça représente — grandir dans l'instabilité, chercher sa place, essayer de se construire quand tout est confus. Et je sais ce que l'art peut offrir comme espace de reconstruction.",
  },

  travaillonsEnsemble: {
    eyebrow: '— Votre projet',
    title: 'Travaillons ensemble.',
    body:
      "Vous accompagnez des jeunes en difficulté et vous cherchez des outils complémentaires pour les soutenir ?\nJe suis disponible pour échanger sur vos besoins et voir comment HeartCanvas peut s'intégrer à votre structure.",
    ctaLabel: 'Prendre contact',
  },
}

// ============================================================================
// 👁  PAGE À PROPOS
// ============================================================================
export const apropos = {
  hero: {
    eyebrow: '— Mon parcours',
    title: '',
  },

  monHistoire: {
    eyebrow: '— Histoire',
    title: 'Mon histoire.',
    paragraphs: [
      "Adolescente, j'ai vécu la violence et la perte de ma liberté de penser et d'agir.",
      "C'est par l'art que je me suis reconstruite.",
      "Aujourd'hui, je suis maman de trois enfants, artiste, et j'accompagne adultes et jeunes dans leur transformation à travers l'art depuis plus de 20 ans.",
    ],
  },

  appris: {
    eyebrow: '— Apprentissages',
    title: "Ce que ça m'a appris.",
    items: [
      'Que ce qui ne peut pas se dire peut se transformer.',
      "Que l'art ne demande aucune technique pour révéler.",
      "Que revenir là où tout a commencé n'est pas regarder en arrière — c'est avancer.",
      "Que tenir un espace, c'est offrir à l'autre la possibilité de se rencontrer.",
    ],
  },

  formation: {
    eyebrow: '— Expertise',
    title: 'Formation et expérience.',
    items: [
      {
        place: 'Paris',
        title: 'Institut de Psychosomatique',
        body: "Diplôme d'art-thérapie relationnelle. Mémoire : \u00ab\u00a0Affranchie d'une secte\u00a0\u00bb (2023).",
      },
      {
        place: 'Paris',
        title: 'Arno Stern \u2014 Le Closlieu',
        body: "Expression du \u00ab\u00a0Jeu de peindre\u00a0\u00bb (2017).",
      },
      {
        place: 'Annecy',
        title: 'Mandalas thérapeutiques',
        body: "Formation avec S. Rouillon (2019).",
      },
      {
        place: 'Atelier',
        title: "Peinture à l'huile",
        body: "Cours avec l'artiste internationale Murielle Argoud (2011\u20132018).",
      },
      {
        place: 'Pratique',
        title: 'Plus de 20 ans',
        body: "Accompagnement d'adultes et de jeunes.",
      },
    ],
  },

  univers: {
    eyebrow: '— Amanaliya',
    title: 'Mon univers artistique.',
    body: "Mon travail d'artiste est présenté sous le nom",
    artistName: 'Amanaliya',
    linkLabel: 'Site artistique : www.amanaliya.com',
  },

  phraseFinale: {
    line1: "« L'art ne s'explique pas.",
    line2Highlight: 'Il révèle.',
    line3: '»',
  },

  invitationFinale: {
    eyebrow: '— Rencontre',
    title: 'Réservons un temps ensemble.',
  },
}

// ============================================================================
// 📞  PAGE CONTACT
// ============================================================================
export const contact = {
  hero: {
    eyebrow: '— Contact',
    title: 'Prenons un moment ensemble.',
    intro: "Vous avez une question, un projet, une hésitation ? Je suis à votre écoute.",
  },

  direct: {
    eyebrow: '— Direct',
    instagramHandle: '@heartcanvas.art',
  },

  doublePorte: {
    eyebrow: '— Deux portes',
    particuliers: 'Particuliers :',
    particuliersText: 'un appel gratuit de 30 min pour faire connaissance.',
    institutions: 'Institutions :',
    institutionsText: 'écrivez-moi un message, je reviens vers toi sous 48h.',
  },

  toggle: {
    particulier: 'Je suis un particulier',
    institution: 'Je représente une institution',
  },

  fields: {
    name: 'Nom',
    email: 'Email',
    org: 'Structure / Institution',
    messageParticulier: 'Ce que tu traverses, en quelques mots',
    messageInstitution: 'Ton besoin, ton public, ton cadre',
  },

  buttons: {
    particulier: 'Réserver un appel gratuit',
    institution: 'Envoyer le message',
  },

  privacyNote: 'Tes informations restent strictement confidentielles. Aucune liste, aucune relance commerciale.',

  success: {
    title: 'Merci.',
    body: 'Ton message est arrivé. Je reviens vers toi dans les 48h, à l\'adresse',
  },
}

// ============================================================================
// 🦶  FOOTER
// ============================================================================
export const footer = {
  brand: 'HeartCanvas',
  quote: "« L\'art ne s\'explique pas. Il révèle. »",
  navigateLabel: 'Naviguer',
  contactLabel: 'Rester en lien',
  artistMention: 'Site artistique :',
  copyright: 'HeartCanvas — Alexandra. Tous droits réservés.',
  tagline: "Atelier de transformation par l'art",
}
